import { useEffect, useState } from 'react';

import { WHATSAPP_MESSAGES } from '../../../core/constants/site';
import { buildWhatsAppUrl } from '../../../core/utils/whatsapp';
import { IconWhatsApp } from '../../../common/icons';

import '../styles/whatsapp-float.css';

// The hero already carries a full-width WhatsApp CTA on mobile; the floating
// button only appears once that CTA has scrolled out of reach.
const VISIBLE_AFTER_SCROLL_PX = 520;

export default function WhatsAppFloat() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => setIsVisible(window.scrollY > VISIBLE_AFTER_SCROLL_PX);
        handleScroll();
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <a
            className={`whatsapp-float ${isVisible ? 'whatsapp-float--visible' : ''}`.trim()}
            href={buildWhatsAppUrl(WHATSAPP_MESSAGES.quote)}
            target="_blank"
            rel="noopener"
            aria-label="Cotizar por WhatsApp"
            tabIndex={isVisible ? undefined : -1}
        >
            <IconWhatsApp size={28} />
        </a>
    );
}
